import { render, staticRenderFns } from "./BannerCardImageSidebarStory.vue?vue&type=template&id=51522909"
import script from "./BannerCardImageSidebarStory.vue?vue&type=script&lang=js"
export * from "./BannerCardImageSidebarStory.vue?vue&type=script&lang=js"
import style0 from "./BannerCardImageSidebarStory.vue?vue&type=style&index=0&id=51522909&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports